import { CreateSubmissionDto, UpdateSubmissionDto } from '@app-types';
import axios from './axios';

const createSubmissionInFillingProcess = async (data: CreateSubmissionDto) => axios.post('/submissions-in-filling-process', data);

const updateSubmissionInFillingProcess = async (id: string, data: UpdateSubmissionDto) => axios.patch(`/submissions-in-filling-process/${id}`, data);

const getCurrentSubmissionInFillingProcess = () => axios.get('/submissions-in-filling-process/current/my');

export default {
  createSubmissionInFillingProcess,
  updateSubmissionInFillingProcess,
  getCurrentSubmissionInFillingProcess,
};
